import React, { useState } from 'react'
import Button, { ButtonProps } from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { getGuid } from '../../utility/getGuid'
import { StyledMenu } from './StyledMenu'
import { Fab, FabProps, Icon } from '@material-ui/core'
import { DropdownListAction } from './DropdownListAction'

interface DropdownListFabButtonProps extends FabProps {
  actions: DropdownListAction[]
}

export const DropdownListFabButton: React.FC<DropdownListFabButtonProps> = ({
  children,
  actions,
  ...buttonProps
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [elementId] = useState<string>(getGuid())

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (actions.length == 1) {
      actions[0].onClick()
      return
    }
    setAnchorEl(event.currentTarget)
    event.preventDefault()
    event.stopPropagation()
  }

  const handleClose = event => {
    setAnchorEl(null)
    event.preventDefault()
    event.stopPropagation()
  }

  // if (actions.length > 1) {
  //   buttonProps.endIcon = <Icon>expand_more</Icon>
  // }

  return (
    <>
      <Fab
        aria-controls={elementId}
        aria-haspopup="true"
        onClick={handleClick}
        {...buttonProps}
      >
        {children}
      </Fab>
      <StyledMenu
        id={elementId}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map(a => (
          <MenuItem
            key={a.text}
            onClick={event => {
              handleClose(event)
              a.onClick()
            }}
          >
            {a.icon && <ListItemIcon>{a.icon}</ListItemIcon>}
            <ListItemText primary={a.text} />
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  )
}
